/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbUploadDocumentTaskItem } from './HchbUploadDocumentTaskItem';
import {
    HchbUploadDocumentTaskItemFromJSON,
    HchbUploadDocumentTaskItemFromJSONTyped,
    HchbUploadDocumentTaskItemToJSON,
} from './HchbUploadDocumentTaskItem';

/**
 * 
 * @export
 * @interface HchbUploadDocumentsTaskBody
 */
export interface HchbUploadDocumentsTaskBody {
    /**
     * 
     * @type {string}
     * @memberof HchbUploadDocumentsTaskBody
     */
    taskType: HchbUploadDocumentsTaskBodyTaskTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof HchbUploadDocumentsTaskBody
     */
    mrn: string;
    /**
     * 
     * @type {Array<HchbUploadDocumentTaskItem>}
     * @memberof HchbUploadDocumentsTaskBody
     */
    documents: Array<HchbUploadDocumentTaskItem>;
}


/**
 * @export
 */
export const HchbUploadDocumentsTaskBodyTaskTypeEnum = {
    UploadDocuments: 'upload_documents'
} as const;
export type HchbUploadDocumentsTaskBodyTaskTypeEnum = typeof HchbUploadDocumentsTaskBodyTaskTypeEnum[keyof typeof HchbUploadDocumentsTaskBodyTaskTypeEnum];


/**
 * Check if a given object implements the HchbUploadDocumentsTaskBody interface.
 */
export function instanceOfHchbUploadDocumentsTaskBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "taskType" in value;
    isInstance = isInstance && "mrn" in value;
    isInstance = isInstance && "documents" in value;

    return isInstance;
}

export function HchbUploadDocumentsTaskBodyFromJSON(json: any): HchbUploadDocumentsTaskBody {
    return HchbUploadDocumentsTaskBodyFromJSONTyped(json, false);
}

export function HchbUploadDocumentsTaskBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbUploadDocumentsTaskBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'taskType': json['taskType'],
        'mrn': json['mrn'],
        'documents': ((json['documents'] as Array<any>).map(HchbUploadDocumentTaskItemFromJSON)),
    };
}

export function HchbUploadDocumentsTaskBodyToJSON(value?: HchbUploadDocumentsTaskBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'taskType': value.taskType,
        'mrn': value.mrn,
        'documents': ((value.documents as Array<any>).map(HchbUploadDocumentTaskItemToJSON)),
    };
}

